React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
ReactBacon = require 'react-bacon'
R = require 'ramda'
cx = require 'classnames'

Rating = require './rating'

{ FormatMessage } = require 'react-globalize'

feedbackStore = require 'stores/feedback'
restaurantStore = require 'stores/restaurant'

findRating = (subject_id, ratings) ->
  R.find R.pipe(R.prop('subject_id'), R.equals(subject_id)), ratings

Question = createReactClass
  mixins: [ReactBacon.BaconMixin]

  props:
    question: PropTypes.object.isRequired
    isActive: PropTypes.bool.isRequired
    onActivate: PropTypes.func.isRequired

  getInitialState: ->
    session: null
    score: null

  componentDidMount: ->
    @plug feedbackStore.feedbackSession, 'session'

  onSetScore: (score) ->
    @setState score: score
    feedbackStore.rate @props.question, score

  renderActive: (score) ->
    buttons = R.map (n) =>
      buttonClass = cx "rface r#{n}", 'active': n == score
      <a key={n} className={buttonClass} onClick={R.partial(@onSetScore, [ n ])}></a>
    , R.range(1, 6)

    boxClass = cx "panel", "panel-important", "panel-center", "panel-swiss", "rating-box"

    <div className={boxClass}>
      <div className="panel-body">
        <div>
          <span key="info" className="panel-info">{@props.question.description}</span>
          <span key="name" className="panel-xxl">{@props.question.name}</span>
          <div className="rating-holder">
            <div className="rating-buttons">
              { buttons }
            </div>
          </div>
        </div>
      </div>
    </div>

  renderInactive: (score, openSession) ->
    classes = cx 'rating-result', 'openSession': openSession
    result = null
    if score > 0
      result = <span key={score} className="rface r#{score} active"></span>

    <div className={classes} onClick={@props.onActivate}>
      <span key="name" className="question">{@props.question.name}</span>
      {result}
    </div>

  render: ->
    unless R.path(['session', 'closed'], @state)
      score = @state.score || R.path(['question', 'rating', 'score'], @props)

      openSession = @state.session and !@state.session.closed

      if @props.isActive
        @renderActive(score)
      else
        @renderInactive(score, openSession)
    else
      null

Review = createReactClass
  mixins: [ReactBacon.BaconMixin]

  getInitialState: ->
    restaurant: null
    reviewText: null
    modified: false
    session: null
    editMode: false

  props:
    review: PropTypes.object.isRequired

  componentDidMount: ->
    @plug restaurantStore.restaurant, 'restaurant'
    @plug feedbackStore.feedbackSession, 'session'

  saveReview: ->
    @setState editMode: false
    feedbackStore.rate @props.review, 0, @state.reviewText

  editReview: ->
    @setState editMode: true

  onUpdateReviewText: ->
    @setState reviewText: @refs.reviewText.value, modified: true, editMode: true

  renderReview: (restaurantName, reviewText) ->
    editReviewClass = cx 'btn', 'btn-primary', 'hidden': @state.session.closed
    rating = if @state.session.closed then [<Rating score={@state.session.average}/>, <br/>]

    <div className="panel panel-important panel-center panel-swiss rating-box">
      <div className="panel-body">
        <div>
          <span className="panel-info">
            <FormatMessage>subjects.review.closed.info</FormatMessage>
          </span>
          <span className="panel-xxl">
            {rating}
            <FormatMessage variables={[restaurantName, @state.session.average]}>subjects.review.closed.label</FormatMessage>
          </span>
          <div>
            {reviewText}
          </div>
          <div className="form-holder">
            <button className={editReviewClass} onClick={@editReview}><FormatMessage>subjects.review.actions.edit</FormatMessage></button>
          </div>
        </div>
      </div>
    </div>

  renderEditableReview: (restaurantName, reviewText) ->
    editButtonClass = cx "btn btn-primary", "hidden": !@state.modified
    <div className="panel panel-important panel-center panel-swiss rating-box">
      <div className="panel-body">
        <div>
          <span className="panel-info"><FormatMessage>subjects.review.open.info</FormatMessage></span>
          <span className="panel-xxl"><FormatMessage>subjects.review.open.label</FormatMessage><strong className="reviewed-restaurant">{restaurantName}</strong></span>
          <div className="form-holder">
            <textarea ref="reviewText" className="form-control" rows="4" value={reviewText} onChange={@onUpdateReviewText}></textarea>
            <button className={editButtonClass} onClick={@saveReview}><FormatMessage>subjects.review.actions.send</FormatMessage></button>
          </div>
        </div>
      </div>
    </div>

  reviewText: ->
    @state.reviewText || R.path ['review', 'rating', 'comment'], @props

  render: ->
    if @state.session
      reviewText = @reviewText()
      reviewTextValid = !!reviewText and reviewText.length > 0
      restaurantName = @state.restaurant.name if @state.restaurant

      editMode = !reviewTextValid or @state.editMode

      if @state.session.closed or !editMode
        @renderReview restaurantName, reviewText
      else
        @renderEditableReview restaurantName, reviewText
    else
      null

module.exports =
  Question: Question
  Review: Review
